// looks ok, but I'd like to expand the 'inventor theme' a bit

const jenniferGameDialogDataset = {
  friendName: "Jennifer",
  dialogTable: [

    // 1. Introduction
    {title: "Jennifer Introduction",
      text: "Hey! Jennifer here! I saw you moving in.' We had some friends in common in high school. " +
       "Even if you don't remember, let’s catch up!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure, you want to come in for a bit?", moodPoints: 2, rltnPoints: +1}, 
        {rspText: "Ok, I really don't remember you. But I'm pretty busy right now.", moodPoints: -1, 
            rltnPoints: -1}
      ]
    },

    // 2. Career Choice
    {title: "Career Choice",
      text: "I went to college for a bit, then decided to become an electrician. I really love the " +
        "work. Plus, it gives me time to think about my inventions!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That's cool. I'll bet it's hard work sometimes.", moodPoints: 1, rltnPoints: +1},
        {rspText: "OK... That's interesting I guess.", moodPoints: -1, rltnPoints: -2}
      ]
    },

    // 3. Nice Compliment
    {title: "Nice Compliment",
      text: "You seem super fun to hang out with! I really like your vibe.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Thanks.", moodPoints: 1, rltnPoints: -1},
        {rspText: "Thanks! I like doing things with you too.", moodPoints: 2, rltnPoints: +2}
      ]
    },

    // 4. Spending Habit
    {title: "Spending Habit",
      text: "Oh no, I spent my paycheck before I even got it! Maybe I’ll live on credit cards for a while… fun times!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That helps in the short term, but don't they charge a lot of interest?", moodPoints: 1, rltnPoints: +1},
        {rspText: "That might be the best thing to do.", moodPoints: -1, rltnPoints: 0}
      ]
    },

    // 5. Family Background
    {title: "Did not have a father",
      text: "My mom raised me alone. Dad left when I was a baby. I used to imagine he'd bring us " +
        "lots of money, but no luck!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That must have been kind of hard.", moodPoints: -1, rltnPoints: +2},
        {rspText: "(shrug) Life's like that sometimes.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 6. Growing Up Poor
    {title: "Grew up poor",
      text: "We didn’t have much money growing up. I had to work and get student loans just " +
        "to make it to college.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Well at least you're putting your education to use.", moodPoints: -1, rltnPoints: 0},
        {rspText: "I can totally relate.", moodPoints: +1, rltnPoints: +1}
      ]
    },

    // 7. Tough Day at Work
    {title: "Job Situation",
      text: "Had a rough day at work today. My coworker dragged things out and the manager " +
        "blamed me. So frustrating!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Do you think your manager was right?", moodPoints: -2, rltnPoints: -2},
        {rspText: "That sounds frustrating.", moodPoints: 2, rltnPoints: +2}
      ]
    },

    // 8. Karaoke Fun
    {title: "Karaoke with Jennifer",
      text: "You wanna go do something fun? Karaoke, escape room, pool… maybe all three!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure, that sounds like fun!", moodPoints: 2, rltnPoints: +2, cashAmt: -63.50, 
            itemDesc: "Karaoke Palace"},
        {rspText: "No, I don't really want to go out.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 9. Dinner Plans
    {title: "Dinner out with Jennifer",
      text: "I wanted to go out for dinner tonight but I’m broke… again. Guess it’s cereal for me.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Yeah, I know that feeling", moodPoints: -1, rltnPoints: -1},
        {rspText: "We can go out to eat... my treat.", moodPoints: +2, rltnPoints: +2, cashAmt: -88.59, 
            itemDesc: "Chinese Tavern"}
      ]
    },

    // 10. Loan Request
    {title: "Loaning money to Jennifer",
      text: "Hey, I’m in a bit of a pinch. Could you lend me a couple hundred bucks? It’s for my " +
        "latest invention… promise it’s a good one!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "I don't have any extra money right now.", moodPoints: -3, rltnPoints: -3, loanedMoney: false},
        {rspText: "Sure, I can do that. Hope you can pay me back soon.", moodPoints: -2, 
            rltnPoints: +5, cashAmt: -200, on: "cashOnly", triggerCondition: "loaned-jennifer-money"}
      ]
    },

    // 11. Car Pickup Help
    {title: "Car Mechanic Assist",
      text: "I need a favor. Can you give me a ride to pick up my car from the mechanic? They finally fixed it!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure, let's go.", moodPoints: -1, rltnPoints: +2},
        {rspText: "Sorry, I am too busy right now.", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 12. New Car Idea
    {title: "New Car Purchase",
      text: "I’ve been eyeing a new car, but it’s super pricey. Might have to choose between the " +
        "car and groceries… tough call!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sounds like you should buy a car that isn’t so expensive.", moodPoints: 2, rltnPoints: -1},
        {rspText: "I’d say go for it. You can make it work somehow.", moodPoints: -1, rltnPoints: 0}
      ]
    },

    // 13. Electric Car Dream
    {title: "Electric Car Purchase",
      text: "I’d love an electric car—better for the planet and fun to drive! But my wallet says 'nope'.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "They are expensive but it is a good idea.", moodPoints: 2, rltnPoints: 2},
        {rspText: "Electric cars are just a hassle.", moodPoints: 1, rltnPoints: -2}
      ]
    },

    // 14. Bicycle Fun
    {title: "New Bicycle",
      text: "I put the car dreams on hold and got a bike instead. Want to go for a ride?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Absolutely, that sounds like fun.", moodPoints: 1, rltnPoints: 2},
        {rspText: "No, I’m too busy.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 15. Loan Partial Repayment
    {title: "Jennifer pays back part of loan",
      text: "I stopped by to give back $100 I borrowed. Thanks for helping me out!",
      conditionList: ["loaned-jennifer-money"], type: "inPerson",
      responses: [
        {rspText: "Thanks, but you still owe me $100.", moodPoints: -2, rltnPoints: -2, cashAmt: 100},
        {rspText: "Thanks!!", moodPoints: -4, rltnPoints: +2, cashAmt: 100}
      ]
    },

    // 16. Expensive Fun Night
    {title: "New Fun Place",
      text: "I went to this fancy new restaurant this weekend. $100 later… totally worth it! You should try it.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds like a waste of money to me.", moodPoints: -1, rltnPoints: -1},
        {rspText: "I would love to try it sometime!", moodPoints: 1, rltnPoints: 1}
      ]
    },

    // 17. Car Comment
    {title: "You have Old Car",
      text: "Your car’s ancient! Thinking about upgrading soon?",
      conditionList: ["car-gt-10-years-old"], type: "inPerson",
      responses: [
        {rspText: "It might be old, but it still runs well.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Maybe soon, I’ve been thinking about it.", moodPoints: 2, rltnPoints: 1}
      ]
    },

    // 18. Starting Own Business
    {title: "Starting Own Business",
      text: "I want to start my own electrician company! Saving money is hard… but hey, I’ve got ideas!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sounds like a great idea to me!", moodPoints: 1, rltnPoints: +2},
        {rspText: "I think it’s easy to save if you really want to.", moodPoints: 2, rltnPoints: 1}
      ]
    },

    // 19. Big TV Purchase
    {title: "Bought New TV",
      text: "I just got a giant TV! Football feels so real now—like I’m at the stadium!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Very cool!", moodPoints: -1, rltnPoints: +1},
        {rspText: "I thought you were saving money?", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 20. Fancy Dinner Invite
    {title: "Expensive Dinner",
      text: "Wanna go to that fancy place I mentioned? $100 dinner but sooo good!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sorry, too rich for my blood.", moodPoints: +1, rltnPoints: -1},
        {rspText: "Sure, sounds like a good idea!", cashAmt: -125.37, 
            itemDesc: "Dinner with Jennifer", moodPoints: -2, rltnPoints: +2}
      ]
    },

    // 21. Hard to Save Money
    {title: "Hard to Save Money",
      text: "Saving money is impossible! I barely have anything in savings right now.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "I can relate, it can be hard to save money.", moodPoints: -1, rltnPoints: +1},
        {rspText: "Maybe you should try not to spend so much money.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 22. Monthly Budget
    {title: "Monthly Budget",
      text: "Someone suggested I make a monthly budget. Good idea, but ugh… planning is boring!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "It might take some time, but it would be a good idea.", moodPoints: 1, rltnPoints: -2},
        {rspText: "Yeah, I know what you mean.", moodPoints: -1, rltnPoints: +1}
      ]
    },

    // 23. Gym Membership
    {title: "Joined a Gym",
      text: "Getting winded at work made me join a gym. $70 a month, ouch!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds really expensive. That’s over $800 per year.", moodPoints: +1, rltnPoints: -2},
        {rspText: "Good idea! I'm sure that'll help with your job.", moodPoints: -1, rltnPoints: +1}
      ]
    },

    // 24. New Furniture
    {title: "New Furniture",
      text: "I bought new furniture for my living room! A little pricey, but looks amazing. Come see?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Absolutely, I would love to see the new furniture!", moodPoints: -1, rltnPoints: +1},
        {rspText: "No, I’m too busy. Weren’t you trying to save money?", moodPoints: -2, rltnPoints: +1}
      ]
    },

    // 25. Loan for Furniture
    {title: "Loan Money",
      text: "Oops, bought that furniture and now I’m broke. Can I borrow $100 from you?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Uh, no! You still owe me $100 from last time.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Yes, I can help you out.", cashAmt: -500.00, itemDesc: "Loaned Jennifer Money", moodPoints: -2, rltnPoints: +5, on: "cashOnly", triggerCondition: "loaned-jennifer-money"}
      ]
    },

    // 26. Game Night
    {title: "Game Night",
      text: "I’m hosting a game night next week! You’re the first person I thought to ask.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Count me in. That sounds like fun!", moodPoints: +2, rltnPoints: +2},
        {rspText: "I don’t think so. I’m no good at games.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 27. Difficulty Saving
    {title: "Difficulty Saving Money",
      text: "I’ve been trying to save for months. Only $100 in the account. Ugh!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That's because you've also been spending more than you should.", moodPoints: +1, 
            rltnPoints: -1},
        {rspText: "I can totally relate. It is really hard to save money.", moodPoints: -2, rltnPoints: +1}
      ]
    },

    // 28. Sky Diving
    {title: "Sky Diving Anyone?",
      text: "Sky diving is on my bucket list. Tandem dive only $300—wanna go?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Count me out. Too expensive and scary!", moodPoints: -1, rltnPoints: -2},
        {rspText: "Wow, that would be so cool! I’m in.", cashAmt: -359, itemDesc: "Sky Diving Adventure", moodPoints: +2, rltnPoints: +2}
      ]
    },

    // 29. Other Electrician Starts Business
    {title: "Another Electrician Started Own Business",
      text: "A coworker quit to start their own company. That’s what I want to do too eventually.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Being your own boss sounds really cool!!", moodPoints: +1, rltnPoints: +1},
        {rspText: "That sounds like a stupid thing to do.", moodPoints: -1, rltnPoints: -2}
      ]
    },

    // 30. New Job Advice
    {title: "New Job Advice",
      text: "Someone started a new company and invited me to join. Pay’s low at first, but should improve. Thoughts?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That could be sort of fun, right?", moodPoints: +1, rltnPoints: +1},
        {rspText: "I wouldn’t think you could afford to say 'Yes'.", moodPoints: -1, rltnPoints: -2}
      ]
    },

    // 31. Want to Go Out
    {title: "Want to Go Out?",
      text: "Want to go out for dinner and drinks? I know some fun spots!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "I’ve got too much to do.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Absolutely! That sounds fun.", cashAmt: -73, itemDesc: "Dinner and Drinks with Jennifer", moodPoints: +2, rltnPoints: +2}
      ]
    },

    // 32. Got New Job
    {title: "Got a New Job",
      text: "I’m starting at that new company next week. Should be fun! Worst case, I can try somewhere else.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "I have a feeling that won’t work out well for you.", moodPoints: -1, rltnPoints: -1},
        {rspText: "I'd say 'Go For It'", moodPoints: 1, rltnPoints: 1},
      ]
    },
           
    // 33. Invention Idea
    {title: "New Invention Idea",
      text: "I just had a crazy idea for a gadget that could save people time at home! I might actually try building it this weekend.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds ambitious! I hope it works.", moodPoints: 2, rltnPoints: 2},
        {rspText: "Uh, sounds complicated. Are you sure?", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 34. Impulsive Shopping
    {title: "Impulsive Shopping Spree",
      text: "I may have bought a new gaming console… and a few games… okay, maybe a LOT of games. Oops!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "At least you’ll have fun with it!", moodPoints: 2, rltnPoints: 1},
        {rspText: "You should really think before spending so much.", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 35. Weekend Adventure
    {title: "Spontaneous Road Trip",
      text: "I’m thinking of taking a weekend road trip to a random town. Care to join? We can " +
        "find adventure along the way!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds amazing! Count me in.", moodPoints: 3, rltnPoints: 3, 
            cashAmt: -270, itemDesc: "Weekend Road Trip"},
        {rspText: "I don’t think I can. Too busy.", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 36. Electrician Tip
    {title: "DIY Electrical Tip",
      text: "I learned a neat trick at work today to make circuits more efficient. " +
        "Want me to show you sometime?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure! I’d love to learn something new.", moodPoints: 1, rltnPoints: 2},
        {rspText: "Not really my thing.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 37. Cooking Disaster
    {title: "Cooking Disaster",
      text: "Tried making a fancy dinner… ended up with something resembling soup from a horror movie. " +
        "Wanna come taste-test? ",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure, I’m brave enough!", moodPoints: 2, rltnPoints: 2},
        {rspText: "No thanks, I’ll pass.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 38. Entrepreneurial Event
    {title: "Startup Networking Event",
      text: "There’s a startup networking event this Friday. Could be good for my electrician business. " +
        "Want to come with me?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sounds interesting. I’ll come along!", moodPoints: 2, rltnPoints: 2, cashAmt: -20, itemDesc: "Startup Networking Ticket"},
        {rspText: "Networking isn’t my thing, sorry.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 39. Late Night Invention
    {title: "Midnight Experiment",
      text: "Stayed up all night testing my new gadget. It kind of works… kind of exploded. But hey, " +
        "progress, right?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Wow, that’s dedication! Hope you’re okay.", moodPoints: 2, rltnPoints: 2},
        {rspText: "Sounds dangerous. Maybe take a break?", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 40. Funny Mishap
    {title: "Funny Mishap",
      text: "I tripped over my own bike this morning in front of a bunch of people… I laughed " +
        "at myself though, so it’s fine!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Good attitude! That’s impressive.", moodPoints: 2, rltnPoints: 2},
        {rspText: "Ouch… hope you’re okay.", moodPoints: -1, rltnPoints: 1}
      ]
    }
  ]
}   

export default jenniferGameDialogDataset
